<style lang="stylus">
    .readonlybox
        .readonlybox-content
            display flex
            margin-bottom 32px

            .readonlybox-smile
                margin-right 8px
                svg
                    stroke #222222

            .readonlybox-text
                display flex
                flex-wrap wrap

                p
                    font-size 12px
                    color #222222

                p:not(:last-child)
                    margin-bottom 8px

        .readonlybox-footer
            display flex
            justify-content flex-end
            div:not(:last-child)
                margin-right 16px
            pcStyleBtn()

        &.dark-theme__readonlybox
            .readonlybox-content
                .readonlybox-smile
                    svg
                        stroke  #fff
                .readonlybox-text
                    p
                        color #fff
</style>
<template>
    <PCStyleModal @closeModal="closeModal" :title="$t('modalTitle')" :width="modalWidth">
        <div class="readonlybox" :class="{ 'dark-theme__readonlybox': isPCDarkMode == 2 }">
            <div class="readonlybox-content">
                <div class="readonlybox-smile">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M16 29C23.1797 29 29 23.1797 29 16C29 8.82029 23.1797 3 16 3C8.82029 3 3 8.82029 3 16C3 23.1797 8.82029 29 16 29Z"
                            stroke="inherit"
                            stroke-width="2"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M21 20C21 20 19.5714 23 16 23C12.4286 23 11 20 11 20"
                            stroke="inherit"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M14.0039 13.5C14.0039 13.5 13.3164 11 11.2539 11C9.19141 11 8.50391 13.5 8.50391 13.5"
                            stroke="inherit"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                        <path
                            d="M23.5 13.5C23.5 13.5 22.8125 11 20.75 11C18.6875 11 18 13.5 18 13.5"
                            stroke="inherit"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
                <div class="readonlybox-text">
                    <p v-html="$t('text1')"></p>
                    <p v-html="$t('text2')"></p>
                </div>
            </div>

            <div class="readonlybox-footer">
                <div class="pcstyle-btn vip-btn" @click="toVip">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            d="M11 18C11 18.5523 10.5523 19 10 19C9.44772 19 9 18.5523 9 18C9 17.4477 9.44772 17 10 17C10.5523 17 11 17.4477 11 18Z"
                            fill="#4A320E"
                        />
                        <path
                            d="M17 18C17 18.5523 16.5523 19 16 19C15.4477 19 15 18.5523 15 18C15 17.4477 15.4477 17 16 17C16.5523 17 17 17.4477 17 18Z"
                            fill="#4A320E"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M4 5.5C4 5.22386 4.22386 5 4.5 5H6.64632C7.12513 5 7.53675 5.33941 7.62799 5.80945L9.33342 14.5954C9.37904 14.8304 9.58485 15.0001 9.82426 15.0001L17.5 15C17.7761 15 18 15.2238 18 15.5C18 15.7761 17.7762 16 17.5 16L9.82428 16.0001C9.10605 16.0001 8.4886 15.491 8.35174 14.786L6.64632 6H4.5C4.22386 6 4 5.77614 4 5.5Z"
                            fill="#4A320E"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M18.4098 8H7.5V7H18.4098C19.0277 7 19.4978 7.55487 19.3962 8.1644L18.6325 12.7466C18.5119 13.4699 17.8861 14 17.1529 14H9V13H17.1529C17.3973 13 17.6059 12.8233 17.6461 12.5822L18.4098 8Z"
                            fill="#4A320E"
                        />
                    </svg>
                    <p>{{ $t("vip") }}</p>
                </div>
                <div class="pcstyle-btn gray-btn" @click="openFile">
                    <p>{{ $t("continue") }}</p>
                </div>
            </div>
        </div>
    </PCStyleModal>
</template>
<script lang="ts">
    import { Component, Prop, Vue, Watch } from "vue-property-decorator";
    import PCStyleModal from "./PCStyleModal.vue";

    @Component({
        components: {
            PCStyleModal,
        },
    })
    export default class ReadOnlyModal extends Vue {
        get readOnlyTempFileLink() {
            return this.$store.state.readOnlyTempFileLink;
        }
        get modalWidth() {
            if (this.lang == "zh") {
                return 360;
            } else {
                return "";
            }
        }
        closeModal() {
            this.$store.commit("setState", {
                type: "showReadOnlyModal",
                data: false,
            });
        }
        toVip() {
            this.$openBuyPage("cloudFilePop");
            this.closeModal();
        }
        openFile() {
            if (this.isPC) {
                let mutiList = this.$store.state.mutOpenList;
                if (mutiList.length > 1) {
                    this.openMuti(mutiList);
                } else {
                    (<any>window).$qt.jsCallOpenUrl(this.readOnlyTempFileLink);
                }
            } else {
                window.open(this.readOnlyTempFileLink, "_blank");
            }
            this.closeModal();
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        openMuti(list) {
            let editFile = [];
            for (let item of list) {
                if (item.info && item.info.edit === false) {
                    let fileName = "&name=";
                    if (item.name) {
                        fileName += item.name;
                    } else if (item.title) {
                        // share file
                        fileName += item.title;
                    } else {
                        let key = item.key || item.obj;
                        fileName += key.match(/[^\/]*(?=\.eddx)/i)[0];
                    }
                    let fileKey = item.key;
                    fileName += "&preview=1&fileLimitTip=1";
                    const userInfo = this.isPC
                        ? `&custom=${btoa(
                              JSON.stringify({
                                  id: this.userInfo.user_id,
                                  token: this.userInfo.token,
                              })
                          )}`
                        : "";
                    let base = (<any>this.$router).options.base;
                    if (base == "/pc/") {
                        base = "/online/";
                    }
                    (<any>window).$qt.jsCallOpenUrl(
                        window.location.origin + base + "app.html?" + this.$zipFileName("obj=" + fileKey + fileName) + userInfo
                    );
                } else {
                    editFile.push(item);
                }
            }
            this.$bus.$emit("openFilesConfirm", true, editFile);
        }
        created() {}
        mounted() {}
    }
</script>
<i18n>
{
    "zh": {
        "modalTitle": "升级提示",
        "text1": "你现在为非会员账号，当前打开的文件仅支持查看。",
        "text2": "开通VIP即可享用<b>无限制的可编辑云文件</b>。",
        "vip": "开通VIP",
        "continue": "继续打开"
    },
    "en": {
        "modalTitle": "Upgrade Reminder",
        "text1": "You are using the Free version, so the current document is only available to view.",
        "text2": "Upgrade to Premium for <b>unlimited Cloud Document editing.</b>",
        "vip": "Buy Now",
        "continue": "Continue opening"
    },
    "fr": {
        "modalTitle": "Rappel de mise à niveau",
        "text1": "Vous utilisez la version gratuite, le document actuel est donc uniquement accessible en lecture.",
        "text2": "Passez à la version Premium pour <b>éditer un nombre illimité de documents cloud.</b>",
        "vip": "Mise à niveau vers Edition Professional",
        "continue": "Poursuivre l'ouverture"
    },
    "de": {
        "modalTitle": "Promemoria di Aggiornamento",
        "text1": "Da Sie die kostenlose Version verwenden, ist das aktuelle Dokument nur zur Ansicht verfügbar.",
        "text2": "Führen Sie ein Upgrade auf Premium durch, um <b>Cloud-Dokumente uneingeschränkt bearbeiten zu können</b>.",
        "vip": "Auf Premium Version upgraden",
        "continue": "Mit dem Öffnen fortfahren"
    },
    "jp": {
        "modalTitle": "アップグレードの通知",
        "text1": "無料バージョンを使用しているため、現在のドキュメントのみを表示できます。",
        "text2": "<b>無制限のクラウドドキュメント編集</b>を得るには、プレミアムにアップグレードしてください。",
        "vip": "プロ版にアップグレード",
        "continue": "続行して開く"
    },
    "es": {
        "modalTitle": "Recordatorio de Actualización",
        "text1": "Está utilizando la versión Gratis, por lo que el documento actual solo estará disponible para su visualización.",
        "text2": "Actualice a Premium para <b>editar documentos en la nube de forma ilimitada.</b>",
        "vip": "Actualizar a la versión Premium",
        "continue": "Continuar para abrir"
    },
    "pt": {
        "modalTitle": "Lembrete de Atualização",
        "text1": "Você está usando a versão gratuita, por isso, o documento atual está disponível para visualização apenas.",
        "text2": "Atualize para a versão Premium para <b>editar documentos na nuvem sem limites.</b>",
        "vip": "Fazer upgrade para Versão Premium",
        "continue": "Continuar abrindo"
    },
    "it": {
        "modalTitle": "Promemoria di Aggiornamento",
        "text1": "Stai utilizzando la versione gratuita, quindi il documento corrente è disponibile solo per la visualizzazione.",
        "text2": "Passa alla versione Premium per la <b>modifica illimitata di documenti per il cloud</b>.",
        "vip": "Esegui l'Upgrade alla Versione Premium",
        "continue": "Continua ad aprire"
    },
    "tw": {
        "modalTitle": "升级提示",
        "text1": "您使用的是免費版本，因此目前的文件僅可供檢視。",
        "text2": "升級至 Premium 即可<b>無限制編輯雲端文件</b>。",
        "vip": "升級VIP會員",
        "continue": "繼續開啟"
    },
    "kr": {
        "modalTitle": "업그레이드",
        "text1": "무료 버전을 사용하고 있으므로 현재 문서는 보기 전용입니다.",
        "text2": "프리미엄으로 업그레이드하여 <b>무제한 클라우드 문서 편집</b>을 이용하십시오.",
        "vip": "VIP 멤버십 업그레이드",
        "continue": "계속하여 열기"
    },
    "id": {
        "modalTitle": "Pengingat Peningkatan",
        "text1": "Anda sedang menggunakan versi Gratis sehingga dokumen saat ini hanya dapat dilihat.",
        "text2": "Tingkatkan ke Premium untuk <b>pengeditan Dokumen Cloud tak terbatas.</b>",
        "vip": "Premium",
        "continue": "Lanjut membuka"
    }
}
</i18n>
